/**
 * StatCard — tutarlı istatistik kutusu (ferah/sade tasarım).
 * Marka renk rolleriyle çalışır; opsiyonel tıklanabilir (filtre) varyantı.
 *
 * @param {string} label
 * @param {string|number} value
 * @param {React.ReactNode} [icon]
 * @param {'brand'|'accent'|'emerald'|'amber'|'red'|'slate'} [tone]
 * @param {boolean} [active]   - seçili/filtre durumu
 * @param {() => void} [onClick]
 */
import { cn } from '@/lib/utils';

const TONES = {
  brand:   { text: 'text-brand-900',   ring: 'ring-brand-500 border-brand-500',   iconBg: 'bg-brand-50 text-brand-700' },
  accent:  { text: 'text-amber-700',   ring: 'ring-amber-500 border-amber-500',   iconBg: 'bg-amber-50 text-amber-600' },
  emerald: { text: 'text-emerald-700', ring: 'ring-emerald-500 border-emerald-500', iconBg: 'bg-emerald-50 text-emerald-600' },
  amber:   { text: 'text-amber-700',   ring: 'ring-amber-500 border-amber-500',   iconBg: 'bg-amber-50 text-amber-600' },
  red:     { text: 'text-red-700',     ring: 'ring-red-500 border-red-500',       iconBg: 'bg-red-50 text-red-600' },
  slate:   { text: 'text-slate-900',   ring: 'ring-slate-800 border-slate-800',   iconBg: 'bg-slate-100 text-slate-600' },
};

export default function StatCard({ label, value, icon, tone = 'brand', active = false, onClick, className }) {
  const t = TONES[tone] || TONES.brand;
  const clickable = typeof onClick === 'function';
  return (
    <div
      role={clickable ? 'button' : undefined}
      tabIndex={clickable ? 0 : undefined}
      onClick={onClick}
      onKeyDown={clickable ? (e) => (e.key === 'Enter' || e.key === ' ') && onClick() : undefined}
      className={cn(
        'bg-white border border-slate-200 rounded-2xl p-4 transition-all select-none',
        clickable && 'cursor-pointer hover:shadow-md hover:border-slate-300 active:scale-[0.99]',
        active && `ring-1 ${t.ring}`,
        className
      )}
    >
      <div className="flex items-center justify-between gap-2">
        <p className="text-[11px] font-semibold uppercase tracking-wide text-slate-400">{label}</p>
        {icon && (
          <span className={cn('w-8 h-8 rounded-lg flex items-center justify-center shrink-0', t.iconBg)}>
            {icon}
          </span>
        )}
      </div>
      {/* DESIGN.md: "Zahlen als Held" — KPI in Cabinet Grotesk */}
      <p className={cn('mt-1 text-3xl font-display font-extrabold tracking-tight tabular-nums', t.text)}>{value}</p>
    </div>
  );
}
